<template>
  <div class="checkbox">
    <input
      type="checkbox"
      :checked="checked"
      :id="id"
      :name="name"
      :value="value"
      :disabled="disabled"
      @change="onChange"
    />
    <label :for="id">
      <span class="input-indicator">
        <icon v-if="disabled" class="icon" icon="checkbox-disabled" size="tiny" />
        <icon v-else class="icon" icon="checkmark" size="tiny" />
      </span>
      <span class="label-value"><slot /></span>
    </label>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    name: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [Boolean, Number, String],
      required: false,
      default: false
    },
    modelValue: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked () {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.indexOf(this.value) > -1
      }
      return this.modelValue
    }
  },
  data () {
    return {
      id: null
    }
  },
  methods: {
    onChange () {
      let value

      if (Array.isArray(this.modelValue)) {
        value = this.modelValue.slice(0)

        if (this.checked) {
          value.splice(value.indexOf(this.value), 1)
        } else {
          value.push(this.value)
        }
      } else {
        value = !this.checked
      }

      this.$emit('input', value)
    }
  },
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  mounted () {
    this.id = `checkbox-${uuid()}`
  }
}
</script>

<style lang="scss" scoped>

.checkbox {
  display: flex;

  input {
    @include visually-hidden();
  }

  label {
    cursor: pointer;
    display: inline-flex;
  }

  .label-value {
    order: 2;
  }
}

.checkbox {
  label {
    @include deprecated-f-color-dark;
    @include label-med;
    @include transition-fast;
    align-items: center;
    border-radius: 4px;
    padding: $d-tiny;
    margin-left: -$d-tiny;
    border: 1px solid rgba($deprecated-brand-tertiary, 0);
  }

  .label-value {
    @include transition-fast;
    @include font('040');
    color: $color-black;
    text-transform: none;
  }

  .input-indicator {
    order: 1;
    display: inline-block;
    position: relative;
    height: $d-x-small;
    width: $d-x-small;
    min-width: $d-x-small;
    border: $line-medium;
    border-radius: 2px;
    margin-right: $d-xx-small;
    @include transition-fast;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    filter: invert(1);
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    transform: scale(0);

    @include transition-fast;

    ::v-deep svg {
      height: 100%;
      width: 100%;
    }
  }

  input:checked {
    & ~ label .input-indicator {
      background-color: $color-black;
      border-color: $color-black;

      .icon {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }
    }
  }

  input:focus {
    & ~ label {
      color: $deprecated-brand-secondary;
      padding: $d-tiny;

      .input-indicator {
        box-shadow: 0 0 4px $deprecated-brand-tertiary;
      }
    }
  }

  input[disabled] {
    ~ label {
      cursor: not-allowed;

      .input-indicator {
        background-color: $deprecated-grey-light;
        border-color: $deprecated-grey-light;

        .icon {
          opacity: 1;
          visibility: visible;
          transform: scale(1);
          filter: invert(0);
        }
      }
    }

    &:checked ~ label  {
      .input-indicator {

        .icon {
          filter: invert(1);
        }
      }
    }
  }
}
</style>
